import React from "react";

// Circular AI score ring widget
export function ScoreRing({ score = 0, size = 56, stroke = 5 }) {
  const r = (size - stroke) / 2;
  const c = 2 * Math.PI * r;
  const pct = Math.min(100, Math.max(0, score));
  const offset = c - (pct / 100) * c;
  const color = pct >= 85 ? "#1aa860" : pct >= 70 ? "#f59e0b" : "#e63946";
  return (
    <div className="relative shrink-0" style={{ width: size, height: size }}>
      <svg width={size} height={size} className="-rotate-90">
        <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke="rgba(255,255,255,0.08)" strokeWidth={stroke} />
        <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke={color} strokeWidth={stroke}
          strokeDasharray={c} strokeDashoffset={offset} strokeLinecap="round"
          style={{ transition: "stroke-dashoffset 0.8s ease" }} />
      </svg>
      <div className="absolute inset-0 grid place-items-center">
        <span className="font-display text-sm font-semibold" style={{ color }}>{score}</span>
      </div>
    </div>
  );
}

export function StatusBadge({ status }) {
  const map = {
    Hot: "bg-brand-red/15 text-brand-red border-brand-red/20",
    Warm: "bg-amber-500/15 text-amber-400 border-amber-500/20",
    Cool: "bg-sky-500/15 text-sky-400 border-sky-500/20",
    Acquired: "bg-brand-green/15 text-brand-green border-brand-green/20",
  };
  return (
    <span className={`rounded-full border px-2 py-0.5 text-[10px] font-semibold ${map[status] || map.Cool}`}>
      {status}
    </span>
  );
}
